(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-footer"] && !Shopify.designMode) return;
  try {
    
  class VPFooter extends HTMLElement {
    connectedCallback() {
      const mobile = window.matchMedia('(max-width: 749px)');
      const toggles = Array.from(this.querySelectorAll('[data-toggle]'));
      const apply = () => toggles.forEach((t) => t.setAttribute('aria-expanded', mobile.matches ? 'false' : 'true'));
      apply();
      mobile.addEventListener('change', apply);
      toggles.forEach((t) => t.addEventListener('click', () => {
        if (!mobile.matches) return;
        t.setAttribute('aria-expanded', t.getAttribute('aria-expanded') === 'true' ? 'false' : 'true');
      }));
      this.querySelectorAll('[data-loc-select]').forEach((s) => s.addEventListener('change', () => s.form && s.form.submit()));
    }
  }
  if (!customElements.get('vp-footer')) customElements.define('vp-footer', VPFooter);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-hero-slider"] && !Shopify.designMode) return;
  try {
    
  class VPHero extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dots = Array.from(this.querySelectorAll('.vp-hero__dot'));
      this.index = 0;
      this.paused = false;
      if (!this.track || this.slides.length < 2) return;

      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
      this.track.addEventListener('pointerdown', () => this.pause(), { passive: true });
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') { this.pause(); this.go(this.index + 1); }
        if (e.key === 'ArrowLeft') { this.pause(); this.go(this.index - 1); }
      });

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.dataset.autoplay === 'true' && !reduce) {
        const interval = parseInt(this.dataset.interval, 10) || 5000;
        this.timer = setInterval(() => { if (!this.paused && !document.hidden) this.go(this.index + 1); }, interval);
      }
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      clearTimeout(this.resume);
    }

    pause() {
      this.paused = true;
      clearTimeout(this.resume);
      this.resume = setTimeout(() => { this.paused = false; }, 8000);
    }

    go(i) {
      const n = this.slides.length;
      const next = ((i % n) + n) % n;
      this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'smooth' });
      this.setActive(next);
    }

    onScroll() {
      const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
      if (i !== this.index) this.setActive(i);
    }

    setActive(i) {
      this.index = i;
      this.dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
    }
  }
  if (!customElements.get('vp-hero')) customElements.define('vp-hero', VPHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-menu"] && !Shopify.designMode) return;
  try {
    
  class VPMenu extends HTMLElement {
    connectedCallback() {
      const open = (e) => {
        if (window.innerWidth >= 990) return; // desktop keeps Horizon's inline menu
        if (e) { e.preventDefault(); e.stopPropagation(); }
        this.hidden = false; document.body.classList.add('vp-menu-open');
        this.querySelector('.vp-menu__close')?.focus({ preventScroll: true });
      };
      const close = () => { this.hidden = true; document.body.classList.remove('vp-menu-open'); };
      document.querySelectorAll('summary.header__icon--menu').forEach((s) => s.addEventListener('click', open, true));
      this.querySelectorAll('[data-vp-menu-close]').forEach((b) => b.addEventListener('click', close));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.hidden) close(); });
      this.querySelectorAll('[data-vp-menu-tab]').forEach((b) => b.addEventListener('click', () => {
        const t = b.dataset.vpMenuTab;
        this.querySelectorAll('[data-vp-menu-tab]').forEach((x) => x.setAttribute('aria-pressed', x.dataset.vpMenuTab === t));
        this.querySelectorAll('[data-vp-menu-pane]').forEach((p) => p.classList.toggle('vp-hide', p.dataset.vpMenuPane !== t));
      }));
      const loc = this.querySelector('[data-vp-menu-loc]');
      loc?.addEventListener('change', () => loc.form?.submit());
      window.addEventListener('resize', () => { if (window.innerWidth >= 990 && !this.hidden) close(); });
    }
  }
  if (!customElements.get('vp-menu')) customElements.define('vp-menu', VPMenu);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-mystery-box"] && !Shopify.designMode) return;
  try {
    
  class VPMystery extends HTMLElement {
    connectedCallback() {
      const plans = Array.from(this.querySelectorAll('[data-plan]'));
      const cta = this.querySelector('[data-cta]');
      const sync = () => {
        const on = plans.find((p) => p.getAttribute('aria-checked') === 'true');
        if (on && cta && on.dataset.link && on.dataset.link !== '#') cta.setAttribute('href', on.dataset.link);
      };
      plans.forEach((p) => p.addEventListener('click', () => {
        plans.forEach((q) => q.setAttribute('aria-checked', q === p ? 'true' : 'false'));
        sync();
      }));
      sync();
    }
  }
  if (!customElements.get('vp-mystery')) customElements.define('vp-mystery', VPMystery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-mystery-product"]) return;
  try {
    
  // Keep the sticky bar visible only while the inline CTA is off-screen (mobile)
  document.querySelectorAll('[data-vp-mystery]').forEach((root) => {
    const row = root.querySelector('[data-vp-cta-row]'), bar = root.querySelector('[data-vp-sticky]');
    if (row && bar && 'IntersectionObserver' in window) new IntersectionObserver(([e]) => bar.classList.toggle('is-on', !e.isIntersecting)).observe(row);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-team-builder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const root = document.querySelector('[data-vp-team-builder]'); if (!root) return;
    const $ = (s, el = root) => el.querySelector(s), $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
    const data = JSON.parse($('[data-vp-kits]').textContent || '{"kits":[],"sizes":[]}');
    if (data.catalogue) {
      /* Catalogue mode: attach the matching variants (own sponsors / Vintage Pitch) to each kit by option value */
      data.kits.forEach((k) => {
        if (k.id) return; /* ids already stored in the catalogue */
        Object.keys(data.variants || {}).forEach((key) => {
          const [kit, sponsor] = key.split('|'); if (kit !== k.name) return;
          const v = data.variants[key];
          if (/vintage pitch/i.test(sponsor)) { k.id_vp = v.id; k.price_vp = v.price; } else { k.id = v.id; k.price = v.price; k.available = v.available; }
        });
        if (!k.id && k.id_vp) { k.id = k.id_vp; k.price = k.price_vp; k.available = true; }
      });
    }
    /* Catalogue rows can name which photo is the real front (the Drive folders don't always put it first) and which
       photos to hide (multi-kit lineups, size charts): show the front first, drop the hidden ones, relabel the rest */
    data.kits.forEach((k) => {
      if (!k.images) return;
      const hide = Array.isArray(k.hide) ? k.hide : [];
      let imgs = k.images.filter((im) => !hide.includes(im.n));
      const fi = imgs.findIndex((im) => im.n === (k.front || 1));
      if (fi > 0) { imgs.unshift(imgs.splice(fi, 1)[0]); }
      imgs.forEach((im, i) => { im.label = i === 0 ? 'Front' : 'View ' + (i + 1); });
      k.images = imgs;
    });
    const KITS = data.kits.filter((k) => k.id && (k.images.length || k.model));
    const SIZES = data.sizes.map((s) => s.trim()).filter(Boolean);
    const kitSizes = () => (st.kit && st.kit.sizes && st.kit.sizes.length ? st.kit.sizes : SIZES);
    const MIN = +root.dataset.min || 5;
    const TIERS = root.dataset.tiers.split(',').map((t) => t.split(':').map(Number)); // [max, price]
    /* Sponsor saving: the price gap between the kit's two variants when the product has them, else the section setting */
    const vpOff = () => (st.kit && st.kit.id_vp && st.kit.price_vp != null ? Math.max(0, (st.kit.price - st.kit.price_vp) / 100) : +root.dataset.vpDiscount || 0);
    const MAX_SP = +root.dataset.maxSponsors || 3;
    const PRINTS = { White: '#ffffff', Black: '#161616', Red: '#e73c28', Gold: '#c9a227' };
    const FACE_LABEL = { front: 'front', back: 'back', lsleeve: 'left sleeve', rsleeve: 'right sleeve' };
    const money = (n) => '$' + Math.round(n).toLocaleString('en-US');
    const st = {
      brand: 'All', style: 'All', kit: KITS[0] || null, angle: 0, print: 'White', crest: null, crestFile: null, nameTop: false, vp: true,
      sponsors: [{ id: 1, type: 'text', text: 'YOUR SPONSOR', img: null, file: null, face: 'front', x: 50, y: 48 }], nextSp: 2, activeSp: 1,
      roster: [], nextId: 1, active: null, team: '', signName: '', email: '', agree: false, status: 'idle', pdfBlob: null, ref: ''
    };
    for (let i = 0; i < MIN; i++) st.roster.push({ id: st.nextId++, name: '', number: '', size: 'M' });
    st.active = st.roster[0].id;
    let dragSp = null, rot = null;

    const toast = (t) => { const el = $('[data-vp-toast]'); $('[data-vp-toast-text]').textContent = t; el.classList.add('is-on'); clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove('is-on'), 2800); };
    const views = () => (st.kit ? st.kit.images : []);
    const viewName = () => (views()[st.angle] ? views()[st.angle].label : '').toLowerCase();
    const isFront = () => views().length <= 1 || st.angle === 0 || viewName().includes('front');
    const isBack = () => viewName().includes('back');
    const isSide = () => viewName().includes('left') || viewName().includes('right');
    const tierFor = (n) => TIERS.find(([max]) => n <= max) || TIERS[TIERS.length - 1];
    const perKit = (n) => (n >= MIN ? tierFor(n)[1] - (st.vp ? vpOff() : 0) : null);

    /* ---------- render ---------- */
    function renderStage() {
      const v = views(); const photo = $('[data-vp-photo]'); const slot = $('[data-vp-model-slot]');
      const useModel = st.kit && st.kit.model && st.angle === 0;
      if (useModel) {
        if (!slot.dataset.model || slot.dataset.model !== st.kit.model) { const t = document.querySelector('template[data-vp-model="' + st.kit.model + '"]'); slot.innerHTML = t ? t.innerHTML : ''; slot.dataset.model = st.kit.model; }
        slot.classList.remove('vp-hide'); photo.classList.add('vp-hide');
      } else { slot.classList.add('vp-hide'); photo.classList.remove('vp-hide'); photo.style.opacity = ''; if (v[st.angle] && photo.getAttribute('src') !== v[st.angle].src) photo.src = v[st.angle].src; }
      $('[data-vp-angle-label]').textContent = st.kit ? st.kit.name + ' · ' + (v[st.angle] ? v[st.angle].label : '3D view') : 'Add kits to the product to start';
      $('[data-vp-crest]').classList.toggle('vp-hide', !isFront() || !st.crest);
      if (st.crest) $('[data-vp-crest-img]').src = st.crest;
      const back = $('[data-vp-back]'); back.classList.toggle('vp-hide', !isBack());
      const act = st.roster.find((r) => r.id === st.active) || st.roster[0] || {};
      $('[data-vp-back-name]').textContent = act.name || 'NAME'; $('[data-vp-back-num]').textContent = act.number || '00';
      $('[data-vp-back-name]').style.color = PRINTS[st.print]; $('[data-vp-back-num]').style.color = PRINTS[st.print];
      $('[data-vp-back-name]').style.top = st.nameTop ? '14%' : '56%'; $('[data-vp-back-num]').style.top = '22%';
      const vl = $('[data-vp-vplogo]'); vl.style.top = st.nameTop ? '80%' : '12%'; vl.classList.toggle('vp-hide', !st.vp);
      const face = isFront() ? 'front' : isBack() ? 'back' : viewName().includes('left') ? 'lsleeve' : 'rsleeve';
      const layer = $('[data-vp-sponsor-layer]'); layer.innerHTML = '';
      st.sponsors.filter((sp) => sp.face === face).forEach((sp) => {
        const el = document.createElement('div'); el.className = 'vp-tb__sp' + (sp.id === st.activeSp ? ' is-on' : ''); el.style.left = sp.x + '%'; el.style.top = sp.y + '%';
        if (sp.type === 'img' && sp.img) { const im = document.createElement('img'); im.src = sp.img; im.alt = 'Sponsor'; im.draggable = false; el.appendChild(im); }
        else if (sp.type === 'img') { const p = document.createElement('span'); p.className = 'ph'; p.textContent = 'SPONSOR LOGO'; el.appendChild(p); }
        else { const t = document.createElement('span'); t.textContent = sp.text || 'SPONSOR'; t.style.color = PRINTS[st.print]; el.appendChild(t); }
        el.addEventListener('pointerdown', (e) => { e.stopPropagation(); dragSp = sp.id; st.activeSp = sp.id; renderSponsors(); });
        layer.appendChild(el);
      });
      const ang = $('[data-vp-angles]'); ang.innerHTML = '';
      v.forEach((im, i) => { const b = document.createElement('button'); b.type = 'button'; b.textContent = im.label; b.className = i === st.angle ? 'is-on' : ''; b.addEventListener('click', () => { st.angle = i; renderStage(); }); ang.appendChild(b); });
      $$('[data-vp-rot]').forEach((b) => (b.style.display = v.length > 1 ? '' : 'none'));
    }
    function renderKits() {
      const brands = ['All', ...new Set(KITS.map((k) => k.brand))].filter((b, i, a) => a.indexOf(b) === i);
      const bw = $('[data-vp-brands]'); bw.innerHTML = ''; bw.classList.toggle('vp-hide', brands.length <= 2);
      brands.forEach((b) => { const btn = document.createElement('button'); btn.type = 'button'; btn.textContent = b; btn.className = st.brand === b ? 'is-on' : ''; btn.addEventListener('click', () => { st.brand = b; st.style = 'All'; renderKits(); }); bw.appendChild(btn); });
      const list = $('[data-vp-kit-list]'); list.innerHTML = '';
      if (!KITS.length) { list.innerHTML = '<p class="vp-tb__note">No kits yet — add "Kit" variants with photos to the Custom Team Uniforms product.</p>'; return; }
      let pool = KITS.filter((k) => st.brand === 'All' || k.brand === st.brand);
      /* Catalogue mode: a second row of pills picks the style (e.g. "Adidas 4"), the cards are its colourways */
      const styles = [...new Set(pool.map((k) => k.style).filter(Boolean))];
      let sw = $('[data-vp-styles]');
      if (!sw) { sw = document.createElement('div'); sw.className = 'vp-tb__brands vp-tb__styles vp-noscroll'; sw.setAttribute('data-vp-styles', ''); bw.after(sw); }
      sw.innerHTML = ''; sw.classList.toggle('vp-hide', styles.length <= 1);
      if (styles.length > 1) {
        if (st.style !== 'All' && !styles.includes(st.style)) st.style = 'All';
        ['All', ...styles].forEach((s) => { const btn = document.createElement('button'); btn.type = 'button'; btn.textContent = s === 'All' ? 'All styles' : s.replace(st.brand === 'All' ? '' : st.brand + ' ', st.brand === 'All' ? '' : 'Style '); btn.className = st.style === s ? 'is-on' : ''; btn.addEventListener('click', () => { st.style = s; renderKits(); }); sw.appendChild(btn); });
        if (st.style !== 'All') pool = pool.filter((k) => k.style === st.style);
      }
      pool.forEach((k) => {
        const b = document.createElement('button'); b.type = 'button'; b.className = 'vp-tb__kit' + (st.kit && st.kit.id === k.id ? ' is-on' : ''); b.disabled = !k.available;
        const meta = [k.images.length > 1 ? k.images.length + ' views' : '1 view', k.model ? '3D' : '', k.youth ? 'youth + adult sizes' : 'adult sizes', 'shorts + socks', k.available ? '' : 'unavailable'].filter(Boolean).join(' · ');
        b.innerHTML = '<span class="vp-tb__kitImg">' + (k.images[0] ? '<img src="' + k.images[0].src + '" alt="" loading="lazy" onerror="this.remove()">' : '') + '</span><span class="vp-tb__kitTxt"><b></b><small></small></span><span class="vp-tb__dot"></span>';
        b.querySelector('b').textContent = k.name; b.querySelector('small').textContent = meta;
        b.addEventListener('click', () => { st.kit = k; st.angle = 0; renderKits(); renderStage(); renderRoster(); renderTotals(); });
        list.appendChild(b);
      });
    }
    function renderSponsors() {
      const wrap = $('[data-vp-sponsor-list]'); wrap.innerHTML = '';
      const max = st.vp ? Math.max(1, MAX_SP - 1) : MAX_SP;
      st.sponsors.forEach((sp, i) => {
        const card = document.createElement('div'); card.className = 'vp-tb__spCard' + (sp.id === st.activeSp ? ' is-on' : '');
        card.innerHTML = '<div class="vp-tb__spHead"><b>Your sponsor ' + (i + 1) + '</b><button type="button" data-rm>Remove</button></div>' +
          '<div class="vp-seg"><button type="button" data-t="text" aria-pressed="' + (sp.type === 'text') + '">Text</button><button type="button" data-t="img" aria-pressed="' + (sp.type === 'img') + '">Logo upload</button></div>' +
          (sp.type === 'text' ? '<input class="vp-tb__input" data-txt placeholder="SPONSOR NAME" maxlength="18">' : '<label class="vp-tb__spUp">' + (sp.img ? 'Replace logo' : 'Upload sponsor logo') + '<input type="file" accept="image/*" data-file></label>') +
          '<div><span class="vp-tb__label" style="margin:0 0 8px;display:block">Placement</span><div class="vp-tb__faces">' + [['front', 'Front'], ['back', 'Back'], ['lsleeve', 'L sleeve'], ['rsleeve', 'R sleeve']].map(([f, t]) => '<button type="button" data-face="' + f + '" class="' + (sp.face === f ? 'is-on' : '') + '">' + t + '</button>').join('') + '</div></div>';
        if (sp.type === 'text') { const inp = card.querySelector('[data-txt]'); inp.value = sp.text; inp.addEventListener('input', () => { sp.text = inp.value.toUpperCase().slice(0, 18); renderStage(); }); inp.addEventListener('focus', () => { st.activeSp = sp.id; goFace(sp.face); }); }
        card.querySelector('[data-rm]').addEventListener('click', () => { st.sponsors = st.sponsors.filter((x) => x.id !== sp.id); renderSponsors(); renderStage(); });
        card.querySelector('b').addEventListener('click', () => { st.activeSp = sp.id; goFace(sp.face); renderSponsors(); });
        card.querySelectorAll('[data-t]').forEach((b) => b.addEventListener('click', () => { sp.type = b.dataset.t; st.activeSp = sp.id; renderSponsors(); renderStage(); }));
        const fi = card.querySelector('[data-file]'); if (fi) fi.addEventListener('change', () => { const f = fi.files && fi.files[0]; if (f) { sp.file = f; sp.img = URL.createObjectURL(f); st.activeSp = sp.id; renderSponsors(); renderStage(); } });
        card.querySelectorAll('[data-face]').forEach((b) => b.addEventListener('click', () => { sp.face = b.dataset.face; sp.x = 50; sp.y = sp.face === 'back' ? (st.nameTop ? 86 : 9) : sp.face === 'front' ? 48 : 22; st.activeSp = sp.id; goFace(sp.face); renderSponsors(); }));
        wrap.appendChild(card);
      });
      const full = st.sponsors.length >= max; const add = $('[data-vp-add-sponsor]'); add.disabled = full;
      $('[data-vp-add-sponsor-label]').textContent = full ? 'Max ' + max + ' sponsors' + (st.vp ? ' with ours' : '') : 'Add a sponsor (' + st.sponsors.length + '/' + max + ')';
      $('[data-vp-sponsor-rule]').textContent = 'Drag your sponsors on the preview to place them. ' + (st.vp ? 'Up to ' + max + ' of yours alongside ours. Our logo stays fixed.' : 'Up to ' + max + ' sponsors.');
      $('[data-vp-vpspot]').textContent = st.nameTop ? 'lower back' : 'upper back';
      $('[data-vp-vp-toggle]').classList.toggle('is-on', st.vp); $('[data-vp-vp-toggle]').setAttribute('aria-checked', st.vp);
    }
    function goFace(face) { const v = views(); const want = face === 'front' ? 'front' : face === 'back' ? 'back' : face === 'lsleeve' ? 'left' : 'right'; const i = v.findIndex((im) => im.label.toLowerCase().includes(want)); st.angle = i >= 0 ? i : 0; renderStage(); }
    function renderRoster() {
      const wrap = $('[data-vp-roster]'); wrap.innerHTML = '';
      st.roster.forEach((r) => {
        const row = document.createElement('div'); row.className = 'vp-tb__player' + (r.id === st.active ? ' is-on' : '');
        const sizes = kitSizes(); if (!sizes.includes(r.size)) r.size = sizes.includes('M') ? 'M' : sizes[0];
        row.innerHTML = '<input data-name placeholder="NAME" aria-label="Player name" maxlength="12"><input data-num placeholder="00" inputmode="numeric" aria-label="Number" maxlength="2"><select aria-label="Size">' + sizes.map((z) => '<option' + (z === r.size ? ' selected' : '') + '>' + z + '</option>').join('') + '</select><button type="button" aria-label="Remove player">×</button>';
        const n = row.querySelector('[data-name]'), num = row.querySelector('[data-num]'), sel = row.querySelector('select');
        n.value = r.name; num.value = r.number;
        const focus = () => { if (st.active !== r.id) { st.active = r.id; $$('.vp-tb__player', wrap).forEach((x) => x.classList.remove('is-on')); row.classList.add('is-on'); } goFace('back'); };
        n.addEventListener('focus', focus); num.addEventListener('focus', focus); sel.addEventListener('focus', focus);
        n.addEventListener('input', () => { r.name = n.value.toUpperCase().replace(/[^A-ZÀ-Ý .'-]/g, '').slice(0, 12); n.value = r.name; renderStage(); });
        num.addEventListener('input', () => { r.number = num.value.replace(/\D/g, '').slice(0, 2); num.value = r.number; renderStage(); });
        sel.addEventListener('change', () => { r.size = sel.value; });
        row.querySelector('button').addEventListener('click', () => { st.roster = st.roster.filter((x) => x.id !== r.id); if (st.active === r.id) st.active = st.roster[0] ? st.roster[0].id : null; renderRoster(); renderTotals(); renderStage(); });
        wrap.appendChild(row);
      });
      const n = st.roster.length; $('[data-vp-roster-count]').textContent = n + ' player' + (n === 1 ? '' : 's') + (n < MIN ? ' · ' + (MIN - n) + ' more needed' : '');
    }
    function renderTotals() {
      const n = st.roster.length, per = perKit(n), off = st.vp ? vpOff() : 0;
      const tw = $('[data-vp-tiers]'); tw.innerHTML = '';
      let lo = MIN; TIERS.forEach(([max, price], i) => { const on = n >= MIN && tierFor(n)[0] === max; const d = document.createElement('div'); d.className = 'vp-tb__tier' + (on ? ' is-on' : ''); d.innerHTML = '<span>' + (max >= 999 ? lo + '+ kits' : lo + '–' + max + ' kits') + '</span><span>' + (on ? '<em>Your tier</em>' : '') + '<b>' + money(price - off) + ' / kit</b></span>'; tw.appendChild(d); lo = max + 1; });
      const next = TIERS.find(([max]) => max >= n && max < 999 && n > max - 1 ? false : max >= 999 ? false : n <= max && false);
      const nextTier = TIERS.find(([max], i) => i > 0 && n < (TIERS[i - 1][0] + 1) && n >= MIN ? false : false);
      let msg = '';
      if (n < MIN) msg = 'Add ' + (MIN - n) + ' more to reach the ' + MIN + '-kit minimum.';
      else { const idx = TIERS.findIndex(([max]) => n <= max); const nt = TIERS[idx + 1]; msg = nt ? 'Add ' + (TIERS[idx][0] + 1 - n) + ' more to drop to ' + money(nt[1] - off) + ' per kit.' : "You're on our best price."; }
      $('[data-vp-next-tier]').textContent = msg;
      $('[data-vp-summary]').textContent = per ? n + ' kits · ' + money(per) + ' each' : n + ' of ' + MIN + ' kits';
      $('[data-vp-total]').textContent = per ? money(per * n) : '—';
      const btn = $('[data-vp-open-proof]'); btn.disabled = n < MIN || !st.kit; btn.textContent = n < MIN ? 'Add ' + (MIN - n) + ' more players' : 'Review & Approve Proof';
    }

    /* ---------- stage interaction ---------- */
    const stage = $('[data-vp-stage]'), face = $('[data-vp-face]');
    /* Photo not imported yet: fade the frame instead of showing a broken-image icon */
    $('[data-vp-photo]').addEventListener('error', function () { this.style.opacity = '0'; });
    stage.addEventListener('pointerdown', (e) => { if (dragSp) return; rot = e.clientX; });
    stage.addEventListener('pointermove', (e) => {
      if (dragSp) { const r = face.getBoundingClientRect(); const sp = st.sponsors.find((x) => x.id === dragSp); if (!sp) return; sp.x = Math.max(10, Math.min(90, ((e.clientX - r.left) / r.width) * 100)); sp.y = Math.max(8, Math.min(92, ((e.clientY - r.top) / r.height) * 100)); renderStage(); return; }
      if (rot !== null && Math.abs(e.clientX - rot) > 50 && views().length > 1) { st.angle = (st.angle + (e.clientX < rot ? 1 : -1) + views().length) % views().length; rot = e.clientX; renderStage(); }
    });
    const up = () => { dragSp = null; rot = null; }; stage.addEventListener('pointerup', up); stage.addEventListener('pointerleave', up);
    $('[data-vp-prev]').addEventListener('click', () => { if (views().length) { st.angle = (st.angle - 1 + views().length) % views().length; renderStage(); } });
    $('[data-vp-next]').addEventListener('click', () => { if (views().length) { st.angle = (st.angle + 1) % views().length; renderStage(); } });

    /* ---------- controls ---------- */
    $$('[data-vp-print]').forEach((b) => b.addEventListener('click', () => { st.print = b.dataset.vpPrint; $$('[data-vp-print]').forEach((x) => x.classList.toggle('is-on', x === b)); renderStage(); }));
    $('[data-vp-crest-input]').addEventListener('change', (e) => { const f = e.target.files && e.target.files[0]; if (!f) return; st.crestFile = f; st.crest = URL.createObjectURL(f); $('[data-vp-crest-thumb]').innerHTML = '<img src="' + st.crest + '" alt="">'; $('[data-vp-crest-label]').textContent = 'Crest added · tap to replace'; goFace('front'); });
    $$('[data-vp-layout]').forEach((b) => b.addEventListener('click', () => { st.nameTop = b.dataset.vpLayout === 'above'; $$('[data-vp-layout]').forEach((x) => x.setAttribute('aria-pressed', x === b)); renderSponsors(); goFace('back'); }));
    $('[data-vp-vp-toggle]').addEventListener('click', () => { const max = MAX_SP - 1; if (!st.vp && st.sponsors.length > max) return toast('Remove one of your sponsors first — up to ' + max + ' alongside ours'); st.vp = !st.vp; renderSponsors(); renderTotals(); goFace('back'); });
    $('[data-vp-add-sponsor]').addEventListener('click', () => { st.sponsors.push({ id: st.nextSp, type: 'text', text: '', img: null, file: null, face: 'front', x: 50, y: 64 }); st.activeSp = st.nextSp++; renderSponsors(); goFace('front'); });
    $('[data-vp-add-player]').addEventListener('click', () => { st.roster.push({ id: st.nextId, name: '', number: '', size: 'M' }); st.active = st.nextId++; renderRoster(); renderTotals(); const last = $$('[data-vp-roster] input[data-name]').pop(); if (last) last.focus(); });
    $('[data-vp-team]').addEventListener('input', (e) => { st.team = e.target.value; });

    /* ---------- proof ---------- */
    const modal = $('[data-vp-proof-modal]');
    const kitLabel = () => (st.kit ? st.kit.name : '');
    function openProof() {
      const n = st.roster.length, per = perKit(n);
      st.ref = 'VP-T' + String(Date.now()).slice(-5);
      $('[data-vp-proof-ref]').textContent = st.ref; $('[data-vp-proof-date]').textContent = new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
      const v = views(); const fi = v.findIndex((im) => im.label.toLowerCase().includes('front')); const bi = v.findIndex((im) => im.label.toLowerCase().includes('back'));
      const front = v[fi >= 0 ? fi : 0], back = v[bi >= 0 ? bi : 0];
      const act = st.roster.find((r) => r.id === st.active) || st.roster[0] || {};
      const spHtml = (f, size) => st.sponsors.filter((sp) => sp.face === f).map((sp) => '<div style="position:absolute;transform:translate(-50%,-50%);left:' + sp.x + '%;top:' + sp.y + '%">' + (sp.type === 'img' && sp.img ? '<img src="' + sp.img + '" style="display:block;max-width:' + size * 7 + 'px;max-height:' + size * 2.5 + 'px">' : '<span style="font:800 ' + size + 'px/1 Inter,sans-serif;text-transform:uppercase;color:' + PRINTS[st.print] + '">' + (sp.text || 'SPONSOR') + '</span>') + '</div>').join('');
      $('[data-vp-proof-front]').innerHTML = (front ? '<img class="bg" src="' + front.src + '" alt="">' : '') + (st.crest ? '<div style="position:absolute;left:56%;top:20%;width:13%;aspect-ratio:1/1;border-radius:3px;overflow:hidden;background:rgba(255,255,255,.6)"><img src="' + st.crest + '" style="width:100%;height:100%;object-fit:contain"></div>' : '') + spHtml('front', 8);
      $('[data-vp-proof-back]').innerHTML = (back ? '<img class="bg" src="' + back.src + '" alt="">' : '') + (st.vp ? '<div style="position:absolute;left:50%;top:' + (st.nameTop ? 80 : 12) + '%;transform:translate(-50%,-50%);background:#fff;border-radius:2px;padding:2px 4px;font:800 6px/1 Inter,sans-serif;color:#161616">VINTAGE PITCH</div>' : '') + '<div style="position:absolute;left:0;right:0;text-align:center;font:700 9px/1 var(--vp-display);letter-spacing:.06em;top:' + (st.nameTop ? 14 : 56) + '%;color:' + PRINTS[st.print] + '">' + (act.name || 'NAME') + '</div><div style="position:absolute;left:0;right:0;text-align:center;font:700 44px/1 var(--vp-display);top:22%;color:' + PRINTS[st.print] + '">' + (act.number || '00') + '</div>' + spHtml('back', 7);
      $('[data-vp-proof-backname]').textContent = act.name || 'NAME';
      const rows = [['Team', st.team || '—'], ['Kit', kitLabel()], ['Font colour', st.print], ['Crest', st.crest ? 'Uploaded · left chest' : 'None'], ['Back layout', st.nameTop ? 'Name above number' : 'Name below number'], ['Vintage Pitch sponsor', st.vp ? 'Yes · ' + (st.nameTop ? 'lower' : 'upper') + ' back' : 'No'], ['Your sponsors', st.sponsors.length ? st.sponsors.map((sp) => (sp.type === 'img' ? 'Logo' : sp.text || 'Text') + ' (' + FACE_LABEL[sp.face] + ')').join(', ') : 'None'], ['Kits', per ? n + ' × ' + money(per) + ' = ' + money(per * n) : String(n)]];
      $('[data-vp-proof-rows]').innerHTML = rows.map(([k, v]) => '<div><span></span><span></span></div>').join('');
      $$('[data-vp-proof-rows] > div').forEach((d, i) => { d.children[0].textContent = rows[i][0]; d.children[1].textContent = rows[i][1]; });
      $('[data-vp-proof-roster]').innerHTML = st.roster.map((r, i) => '<div><span style="color:#8a8683">' + (i + 1) + '</span><span></span><span></span><span></span></div>').join('');
      $$('[data-vp-proof-roster] > div').forEach((d, i) => { const r = st.roster[i]; d.children[1].textContent = r.name || '—'; d.children[2].textContent = r.number || '—'; d.children[3].textContent = r.size; });
      modal.classList.remove('vp-hide'); document.body.style.overflow = 'hidden';
    }
    const closeProof = () => { modal.classList.add('vp-hide'); document.body.style.overflow = ''; };
    $('[data-vp-open-proof]').addEventListener('click', openProof);
    $$('[data-vp-close-proof]').forEach((b) => b.addEventListener('click', closeProof));
    const ready = () => st.signName.trim().length > 1 && /\S+@\S+\.\S+/.test(st.email) && st.agree && st.status !== 'busy';
    const syncApprove = () => { $('[data-vp-approve]').disabled = !ready(); };
    $('[data-vp-sign-name]').addEventListener('input', (e) => { st.signName = e.target.value; syncApprove(); });
    $('[data-vp-sign-email]').addEventListener('input', (e) => { st.email = e.target.value.trim(); syncApprove(); });
    $('[data-vp-agree]').addEventListener('change', (e) => { st.agree = e.target.checked; syncApprove(); });

    const loadScript = (src) => new Promise((res, rej) => { if (document.querySelector('script[src="' + src + '"]')) return res(); const sc = document.createElement('script'); sc.src = src; sc.onload = res; sc.onerror = rej; document.head.appendChild(sc); });
    async function makePdf() {
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/html2canvas/1.4.1/html2canvas.min.js');
      await loadScript('https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js');
      const canvas = await window.html2canvas($('[data-vp-proof]'), { scale: 2, backgroundColor: '#ffffff', useCORS: true });
      const { jsPDF } = window.jspdf; const w = 595, h = Math.round(canvas.height * (w / canvas.width));
      const pdf = new jsPDF({ unit: 'pt', format: [w, h] }); pdf.addImage(canvas.toDataURL('image/jpeg', 0.92), 'JPEG', 0, 0, w, h);
      return pdf.output('blob');
    }
    async function addToCart() {
      const n = st.roster.length, per = perKit(n);
      const shared = { 'Team': st.team || '—', 'Kit': kitLabel(), 'Font colour': st.print, 'Back layout': st.nameTop ? 'Name above number' : 'Name below number', 'Vintage Pitch sponsor': st.vp ? 'Yes' : 'No', 'Sponsors': st.sponsors.length ? st.sponsors.map((sp) => (sp.type === 'img' ? 'Logo file' : sp.text || 'Text') + ' (' + FACE_LABEL[sp.face] + ')').join(', ') : 'None', 'Proof ref': st.ref, 'Approved by': st.signName + ' (' + st.email + ')', 'Agreed price per kit': per ? money(per) : '' };
      for (let i = 0; i < st.roster.length; i++) {
        const r = st.roster[i]; const fd = new FormData();
        fd.append('id', st.vp && st.kit.id_vp ? st.kit.id_vp : st.kit.id); fd.append('quantity', '1');
        fd.append('properties[Player]', r.name || '—'); fd.append('properties[Number]', r.number || '—'); fd.append('properties[Size]', r.size);
        Object.keys(shared).forEach((k) => fd.append('properties[' + k + ']', shared[k]));
        if (i === 0) {
          if (st.crestFile) fd.append('properties[Crest file]', st.crestFile, st.crestFile.name);
          st.sponsors.filter((sp) => sp.type === 'img' && sp.file).forEach((sp, j) => fd.append('properties[Sponsor logo ' + (j + 1) + ']', sp.file, sp.file.name));
          if (st.pdfBlob) fd.append('properties[Signed proof]', st.pdfBlob, st.ref + '-proof.pdf');
        }
        const res = await fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
        if (!res.ok) { const j = await res.json().catch(() => ({})); throw new Error(j.description || j.message || 'Could not add to cart'); }
      }
      await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: { 'Team kit proof': st.ref, 'Team': st.team || '', 'Proof approved by': st.signName, 'Proof email': st.email } }) });
    }
    $('[data-vp-approve]').addEventListener('click', async () => {
      if (!ready()) return;
      st.status = 'busy'; syncApprove(); const err = $('[data-vp-proof-err]'); err.classList.add('vp-hide');
      const btn = $('[data-vp-approve]'); btn.textContent = 'Generating proof…';
      const when = new Date().toLocaleString('en-US', { dateStyle: 'medium', timeStyle: 'short' });
      const sg = $('[data-vp-signed]'); sg.innerHTML = 'Approved by <strong></strong> (<span></span>) on ' + when + '. Production follows this proof exactly.'; sg.querySelector('strong').textContent = st.signName; sg.querySelector('span').textContent = st.email; sg.classList.remove('vp-hide');
      try { st.pdfBlob = await makePdf(); } catch (e) { st.pdfBlob = null; }
      try {
        btn.textContent = 'Adding to cart…';
        await addToCart();
        st.status = 'done';
        $('[data-vp-sign]').classList.add('vp-hide'); $('[data-vp-done]').classList.remove('vp-hide'); $('[data-vp-done-email]').textContent = st.email;
        const dl = $('[data-vp-pdf-link]'); if (st.pdfBlob) { dl.href = URL.createObjectURL(st.pdfBlob); dl.download = st.ref + '-proof.pdf'; } else dl.classList.add('vp-hide');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (e) { st.status = 'idle'; btn.textContent = 'Approve & Add to Cart'; syncApprove(); err.textContent = e.message || 'Something went wrong. Try again or message us on WhatsApp.'; err.classList.remove('vp-hide'); }
    });

    renderKits(); renderStage(); renderSponsors(); renderRoster(); renderTotals();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vp-ticker"] && !Shopify.designMode) return;
  try {
    
  class VPTicker extends HTMLElement {
    connectedCallback() {
      const track = this.querySelector('[data-track]');
      if (!track) return;
      // Clone until the (duplicated) track is at least twice the viewport so the -50% loop never shows a gap.
      const items = Array.from(track.children);
      let guard = 0;
      while (track.scrollWidth < window.innerWidth * 2 && guard < 6) {
        items.forEach((n) => { const c = n.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
        guard++;
      }
    }
  }
  if (!customElements.get('vp-ticker')) customElements.define('vp-ticker', VPTicker);

  } catch(e) { console.error(e); }
})();
})();
